var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.670067 0.669278C0.876209 0.464093 1.19879 0.445439 1.4261 0.613318L1.49122 0.669278L6.5 5.65455L11.5088 0.669278C11.7149 0.464093 12.0375 0.445439 12.2648 0.613318L12.3299 0.669278C12.5361 0.874463 12.5548 1.19554 12.3862 1.4218L12.3299 1.48662L6.91058 6.88083C6.70444 7.08601 6.38186 7.10467 6.15455 6.93679L6.08942 6.88083L0.670067 1.48662C0.443311 1.26092 0.443311 0.894982 0.670067 0.669278Z",
    fill: "#222222",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3299 12.3307C12.1238 12.5359 11.8012 12.5546 11.5739 12.3867L11.5088 12.3307L6.5 7.34545L1.49122 12.3307C1.28508 12.5359 0.962503 12.5546 0.735191 12.3867L0.670067 12.3307C0.463926 12.1255 0.445185 11.8045 0.613847 11.5782L0.670067 11.5134L6.08942 6.11917C6.29556 5.91399 6.61814 5.89533 6.84545 6.06321L6.91058 6.11917L12.3299 11.5134C12.5567 11.7391 12.5567 12.105 12.3299 12.3307Z",
    fill: "#222222",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearInput);
export default __webpack_public_path__ + "static/media/clear-input.a0a8d8bc03019240f3b8a70230246fba.svg";
export { ForwardRef as ReactComponent };